import { KeyValue } from '@/main/models/common';
import { CompanyTypeEnum } from '@/main/services/enum/CompanyTypeEnum';
import { getTranslateByKey } from '@/main/services/utils';

function changeTranslatesToWhoSees(options: KeyValue[]): KeyValue[] {
  const result = options.map(option => {
    if (option.key === CompanyTypeEnum.Admin) {
      return {
        ...option,
        value: getTranslateByKey('companyType.admin')
      };
    }

    if (option.key === CompanyTypeEnum.BodyShop) {
      return {
        ...option,
        value: getTranslateByKey('companyType.bodyshop')
      };
    }

    return option;
  });

  return result;
}

export function findCompanyTypeByTranslate(
  translate: string,
  options: KeyValue[]
): KeyValue | null {
  const filteredOptions = changeTranslatesToWhoSees(options);

  const finded = filteredOptions.find(option => option.value === translate);
  if (!finded) return null;

  const findedOption = options.find(option => option.key === finded.key);
  return findedOption || null;
}

export function isSameRecipientCompanyTypeByUser(
  translate: string,
  companyTypeUserLogged: CompanyTypeEnum,
  options: KeyValue[]
): boolean {
  const filteredOptions = findCompanyTypeByTranslate(translate, options);

  return filteredOptions?.key === companyTypeUserLogged;
}

export function getOptionByCompanyType(
  companyType: CompanyTypeEnum,
  options: KeyValue[]
): KeyValue | null {
  const option = options.find(item => item.key === companyType);
  return option || null;
}

export function getOptionAdmin(options: KeyValue[]): KeyValue | null {
  return getOptionByCompanyType(CompanyTypeEnum.Admin, options);
}

export function getOptionByIdSenderCompanyType(
  options: KeyValue[],
  idSenderCompanyType: number
): KeyValue | null {
  const option = options.find(item => item.key === idSenderCompanyType);
  return option || null;
}

export function getWhoSeesByIdSenderCompanyType(
  idSenderCompanyType: number,
  options: KeyValue[]
): KeyValue[] {
  const whoSees = options.filter(item => item.key === idSenderCompanyType);
  return whoSees;
}

